<button
  [attr.id]="ID(textButton)"
  [attr.data-testid]="dataTestID(textButton)"
  class="btn btn-lg btn-block custom-button"
  [ngStyle]="{ 'background-color': buttonColor() }"
>
  {{ textButton }}
</button>
